import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { notEmpty } from '@crehana/utils';
import deburr from 'lodash.deburr';
var GET_CHILD_ORGANIZATIONS = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "MainMenuGetChildOrganizations" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "slug" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, directives: [] }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "b2bOrganization" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "parentSlug" }, value: { kind: "Variable", name: { kind: "Name", value: "slug" } } }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "originalId" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "slug" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "name" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "limitPay" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "startDate" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "expireDate" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "country" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "slug" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "adminName" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "adminEmail" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "countryId" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "isCorporation" }, arguments: [], directives: [] }] } }] } }], loc: { start: 0, end: 256, source: { body: "query MainMenuGetChildOrganizations($slug: String!) {\n  b2bOrganization(parentSlug: $slug) {\n    originalId\n    slug\n    name\n    limitPay\n    startDate\n    expireDate\n    country\n    slug\n    adminName\n    adminEmail\n    countryId\n    isCorporation\n  }\n}\n", name: "GraphQL request", locationOffset: { line: 1, column: 1 } } } };
var searchStr = function searchStr(str, searchKey) {
  return deburr(str).toLocaleLowerCase().includes(deburr(searchKey).toLocaleLowerCase());
};
var useChildOrganizations = function useChildOrganizations(_ref) {
  var slug = _ref.slug,
    searchKey = _ref.searchKey,
    _ref$skip = _ref.skip,
    skip = _ref$skip === void 0 ? false : _ref$skip;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    organizations = _useState2[0],
    setOrganizations = _useState2[1];
  var _useQuery = useQuery(GET_CHILD_ORGANIZATIONS, {
      variables: {
        slug: slug
      },
      skip: skip,
      context: {
        clientName: 'v4.b2b'
      }
    }),
    data = _useQuery.data,
    loading = _useQuery.loading,
    error = _useQuery.error,
    refetch = _useQuery.refetch;
  useEffect(function () {
    if (data !== null && data !== void 0 && data.b2bOrganization) {
      var _data$b2bOrganization;
      var newOrganizations = (data === null || data === void 0 ? void 0 : (_data$b2bOrganization = data.b2bOrganization) === null || _data$b2bOrganization === void 0 ? void 0 : _data$b2bOrganization.filter(notEmpty)) || [];
      if (searchKey) {
        newOrganizations = newOrganizations.filter(function (org) {
          return searchStr((org === null || org === void 0 ? void 0 : org.name) || '', searchKey);
        });
      }
      if (newOrganizations.length > 0) {
        setOrganizations(newOrganizations);
      }
    }
  }, [searchKey, data === null || data === void 0 ? void 0 : data.b2bOrganization]);
  return {
    organizations: organizations,
    loading: loading,
    error: error,
    refetch: refetch
  };
};
export default useChildOrganizations;